import { Box, Divider, Grid, SxProps, Theme, Typography } from '@mui/material';
import Label from '../../../../../../components/MUIComponents/Label';
import { LabelTypeEnum } from '../../../../../../enums/label-enum';
import { IWorkExperience } from '../../../../../../interfaces/user-work-experience.interface';
import { workTypeLabelPlugin } from '../../../../../../utils/helper/workTypeEnumValuePlugin';
import { foramtCareerDate } from '../../../../../../utils/profile-page/format-career-date';

interface IWorkExperiencesList {
  workExperiences: IWorkExperience[];
}
const WorkExperiencesList = (props: IWorkExperiencesList) => {
  const { workExperiences } = props;

  const formatEnumValues = (str: string) => {
    const loweredStr = str.toLowerCase().replaceAll('_', '-');

    return loweredStr.charAt(0).toUpperCase() + loweredStr.substring(1);
  };

  return (
    <>
      {workExperiences.map((workExp, index) => (
        <Box display={'flex'} flexDirection={'column'} key={workExp.id}>
          {index !== 0 && <Divider sx={{ m: '2.25rem 0' }} />}

          <Grid
            container
            rowGap="28px"
            marginTop={index === 0 ? '2.25rem' : 0}
            sx={gridContainerStyles}
          >
            <Grid item display="flex" flexDirection="row">
              <Typography className="label" variant="caption">
                Company name:
              </Typography>
              <Typography className="plain-text" variant="body3">
                {`${workExp?.companyName ?? ''}`}
              </Typography>

              {workExp.isActiveAthlete && (
                <Label labelType={LabelTypeEnum.VERIFIED}>active athlete</Label>
              )}
            </Grid>
            <Grid item display="flex" flexDirection="row">
              <Typography className="label" variant="caption">
                Career timeline:
              </Typography>
              <Typography className="plain-text" variant="body3">
                {foramtCareerDate(workExp.startDate)} -{' '}
                {!workExp.activeWork
                  ? foramtCareerDate(workExp.endDate ?? '')
                  : 'Current'}
              </Typography>
            </Grid>
            <Grid item display="flex" flexDirection="row">
              <Typography className="label" variant="caption">
                Title:
              </Typography>
              <Typography className="plain-text" variant="body3">
                {workExp.title ?? ''}
              </Typography>
            </Grid>
            <Grid item display="flex" flexDirection="row">
              <Typography className="label" variant="caption">
                Employment type:
              </Typography>
              <Typography className="plain-text" variant="body3">
                {formatEnumValues(workExp.employmentType) ?? ''}
              </Typography>
            </Grid>
            <Grid item display="flex" flexDirection="row">
              <Typography className="label" variant="caption">
                Location:
              </Typography>
              <Typography className="plain-text" variant="body3">
                {workExp.location ?? ''}
              </Typography>
            </Grid>
            <Grid item display="flex" flexDirection="row">
              <Typography className="label" variant="caption">
                Work type:
              </Typography>
              <Typography className="plain-text" variant="body3">
                {formatEnumValues(workTypeLabelPlugin(workExp.workType)) ?? ''}
              </Typography>
            </Grid>
            <Grid item display="flex" flexDirection="row">
              <Typography className="label" variant="caption">
                Description:
              </Typography>
              <Typography className="plain-text" variant="body3">
                {workExp.responsibilities ?? ''}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      ))}
    </>
  );
};

export default WorkExperiencesList;

const gridContainerStyles: SxProps<Theme> = theme => ({
  '& .label': {
    width: 165,
    flexShrink: 0,
  },
  '& .plain-text': {
    fontWeight: 400,
    lineHeight: '140%',
    color: theme.palette.text.primary,

    textAlign: 'left',
    flexGrow: '1',
    wordWrap: 'break-word',
    whiteSpace: 'normal',
    minWidth: 0,
  },
  '& .MuiGrid-item': {
    width: '100%',
  },
});
